import { INSPECTION_METHODS } from '@/constants/accessor/api/emergencyInspectionResult/assessmentDetails/step1/inspectionMethod'

/** 外観調査内観調査 */
export const INSPECTION_METHOD_LABELS = [
  { value: INSPECTION_METHODS.EXTERNAL, text: '外観調査のみ実施' },
  { value: INSPECTION_METHODS.INTERNAL, text: '内観調査も併せて実施' }
] as const
